import React, { Fragment, useEffect, useState } from "react";
import { renderToString } from 'react-dom/server';
import { useField, useFormikContext } from "formik";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SummaryItem from "../components/SummaryItem/SummaryItem";

import Autosuggest from "react-autosuggest";

import "./SuggestionInputField.scss";

import Modal from "../../common/Modal/Modal";

export default function SuggestionInputField(props) {
  const {
    errorText,
    getItems,
    getSuggestions,
    filter,
    onSelected,
    onBlur,
    renderSuggestion = (suggestion) => {
      return <div>{suggestion.comune}</div>;
    },
    getSuggestionValue = (suggestion) => {
      return suggestion.comune;
    },
    validationSchema,
    ...rest
  } = props;

  const [field, meta] = useField(props);
  const { summaryMode } = rest;
  const { t } = useTranslation();
  const hasIcon = props.leftIcon ? "has-icon" : "";
  const [fieldPass, setFieldPass] = useState(false);
  const [value, setValue] = useState(field.value);
  const [suggestions, setSuggestions] = useState([]);

  const [data, setData] = useState([]);
  const [isSentDataLayer, setIsSentDataLayer] = useState(false);
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;
  const { setFieldValue } = useFormikContext();
  useEffect(() => {
    getItems(setData);
  }, [getItems]);

  useEffect(() => {
    getSuggestions(data);
  }, [getSuggestions, data]);

  useEffect(() => {
    setFieldValue(field.name, value);
    // eslint-disable-next-line
  }, [value, field.name]);

  const onSuggestionsFetchRequested = async ({ value }) => {
    const filteredSuggestions = filter(value, data, setData);
    const suggestions = Array.isArray(filteredSuggestions)
      ? filteredSuggestions
      : await filteredSuggestions;
    setSuggestions(suggestions);
  };

  const onSuggestionsClearRequested = (props) => {
    setSuggestions(getSuggestions([]));
  };

  const _onChange = (event, { newValue, method }) => {
    setValue(newValue);
    onSelected(newValue, data, setFieldValue);
  };

  const _onBlur = (event, { newValue }) => {
    onBlur(value, data, setValue, isSentDataLayer, setIsSentDataLayer);
  };

  const renderInputComponent = (inputProps) => {
    const { key, ...restInputProps } = inputProps;
    return (
    <Form.Control
      key={key}
      type="text"
      name={field.name}
      placeholder={
        typeof rest.placeholder === "object"
          ? t(rest.placeholder.props.i18nKey)
          : rest.placeholder
      }
      value={field.value || ""}
      onChange={field.onChange}
      className={meta.touched && meta.error ? "is-invalid" : ""}
      disabled={rest.disabled}
      aria-describedby={
        meta.touched && meta.error ? field.name + "-error" : null
      }
      required={isRequired}
      id={field.name}
      {...restInputProps}
    />
  )};

  return (
    <Form.Group>
      
      {!summaryMode ? (
        <>
          {rest.label && (
            <Form.Label className="paragraph-small-fs9" htmlFor={field.name}>
              {rest.label}
              {props.message ? (
                <button
                  type="button"
                  className={"form-info-button"}
                  aria-label={t("aria.form.info.button")}
                  aria-haspopup="dialog"
                  aria-controls={field.name + "-info-modal"}
                  onClick={() => {
                    setFieldPass(true);
                  }}
                >
                  {" "}
                  <span className="form-icon-info" aria-hidden="true"></span>
                </button>
              ) : null}
            </Form.Label>
          )}
          <Fragment>
            <Autosuggest
              suggestions={suggestions}
              onSuggestionsFetchRequested={onSuggestionsFetchRequested}
              onSuggestionsClearRequested={onSuggestionsClearRequested}
              getSuggestionValue={getSuggestionValue}
              renderSuggestion={renderSuggestion}
              renderInputComponent={renderInputComponent}
              inputProps={{
                placeholder:
                  typeof rest.placeholder === "object"
                    ? t(rest.placeholder.props.i18nKey)
                    : rest.placeholder,
                className:
                  meta.touched && meta.error
                    ? "gcap-select  is-invalid"
                    : "gcap-select",
                value,
                onChange: _onChange,
                onBlur: _onBlur,
              }}
            />

            {meta.touched && meta.error && (
              <p
                className="form-error-text paragraph-small-form"
                role="alert"
                id={field.name + "-error"}
              >
                {meta.error}
              </p>
            )}
          </Fragment>
        </>
        
      ) : (
        <>
          <div className="form-group-info">
            {rest.label && (
              <span className="paragraph-small-fs9" htmlFor={field.name}>
                {rest.label}
              </span>
            )}
            {rest.label && props.message ? (
              <button
                type="button"
                className={"form-info-button"}
                aria-label={`${t("aria.form.info.button")}[${renderToString(rest.label)}]`}
                aria-haspopup="dialog"
                aria-controls={field.name + "-info-modal"}
                onClick={() => {
                  setFieldPass(true);
                }}
              >
                {" "}
                <span className="form-icon-info" aria-hidden="true"></span>
              </button>
             ) : null}
          </div>
          <SummaryItem value={field.value} error={meta.error} />
        </>
        
      )}
      {fieldPass ? (
        <Modal
          show={fieldPass}
          onClose={() => setFieldPass(false)}
          description={t("comune.info.message")}
          type={"button"}
          styleType={"primary"}
          onFirstClick={() => setFieldPass(false)}
          linkTitle={t("common.hoCapito")}
        />
      ) : null}
      {props.subtitle ? (
        <p className="paragraph-small-form">{props.subtitle}</p>
      ) : null}
    </Form.Group>
  );
}
